import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { registerServiceWorker } from './services/fcmService'

// Register Firebase messaging service worker
if ('serviceWorker' in navigator) {
  // When a new service worker takes over, reload once so this page isn't left running old code
  const hadController = !!navigator.serviceWorker.controller
  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return
    reloading = true
    window.location.reload()
  })

  registerServiceWorker()
    .then((registration) => {
      console.log('Firebase messaging service worker registered')
      // Phones often resume a tab without reloading it, so check for a new version on every return
      registration.update().catch(() => {})
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') registration.update().catch(() => {})
      })
    })
    .catch((error) => {
      console.error('Firebase messaging service worker registration failed:', error)
    })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
